import { render, staticRenderFns } from "./annotation_form.vue?vue&type=template&id=63f246eb&scoped=true&"
import script from "./annotation_form.vue?vue&type=script&lang=ts&"
export * from "./annotation_form.vue?vue&type=script&lang=ts&"
import style0 from "./annotation_form.vue?vue&type=style&index=0&id=63f246eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f246eb",
  null
  
)

export default component.exports